<div class="content_main-drawer-container">
  @if (currentDisplay === 'menu') { 
    @if(menuTitleKey) {
    <div class="mb-25">
      <h2>{{ menuTitleKey | translate }}</h2>
    </div>
  }
  @for (option of options; track option) {
  <button
    mat-menu-item
    (click)="click(option)"
    id="menu_{{ option.action | lowercase }}-btn"
    [attr.aria-label]="option.label | translate"
    [ngClass]="{ 'reverse-icon': reverseButtonIcon }"
    [disabled]="
      (option.disabled | typeOf) === 'function' ? option && $any(option?.disabled)(item, itemIndex) : option.disabled
    "
  >
    <mat-icon class="mr-12">{{ option.icon }}</mat-icon>
    <span class="mat-body-2">
      {{ option.label | translate }}
    </span>
  </button>
  } } @for (option of options; track option) { @if (currentDisplay === option.action) { @if (!isErrorInline &&
  errorKey) {
  <pbb-notice
    class="mt-8"
    [title]="errorKey | translate"
    [inline]="isErrorInline"
    id="dialog_action_message"
    [type]="notice.ERROR"
    [showInContainer]="false"
  ></pbb-notice>
  } @if (!option.showLogo && !option.deleteTrusted) {
  <mat-icon class="confirm-icon">{{ option.icon }}</mat-icon>
  }

  <h2 class="mat-body-1 text-bold mb-4" id="menu_{{ option.action | lowercase }}_title">
    {{ getTranslation(option, 'confirmTitle') }}
  </h2>
  <span class="mat-body-2 text-grey-subtitle mb-24" id="menu_{{ option.action | lowercase }}_info">
    {{ getTranslation(option, 'confirmSubtitle') }}
  </span>

  @if (option.showLogo) {
  <pbb-bank-info [logo]="option.logo" [imageSrc]="option.imageSrc" [name]="item.display_name"></pbb-bank-info>
  } @if (option.deleteTrusted) {
  <pbb-card [class.delete-trusted]="option.deleteTrusted" class="card card_column card_normal" id="trusted-device-card">
    <mat-card-content>
      <div class="trusted-device-details">
        <span matListItemLine id="trusted-device-user-agent" class="mat-body-1 text-bold">
          {{ item.user_agent | uaParser }}
        </span>
        @if (item.trusted !== null) {
        <span matListItemLine id="trusted-device-biometrics" class="mat-body-2 text-grey-subtitle">
          {{
            (item?.webauthn_enabled
              ? 'USER_PORTAL.MANAGE_TRUSTED_DEVICES.BIO_ENABLED'
              : 'USER_PORTAL.MANAGE_TRUSTED_DEVICES.BIO_DISABLED'
            ) | translate
          }}
        </span>
        } @if (item.trusted !== null) {
        <span matListItemLine id="trusted-device-last-login-info" class="mat-body-2 text-grey-subtitle">
          {{ 'USER_PORTAL.TRUSTED_DEVICES.LAST_LOGGED_IN' | translate }}
          {{ item?.last_login_info?.timestamp | timeAgo }}
        </span>
        } @if (item.current) {
        <mat-basic-chip matListItemLine class="device-chip mt-16" id="trusted-device-default-chip">
          <mat-icon class="icon-sm text-black">check_circle</mat-icon>
          <span class="mat-caption text-info">{{ 'USER_PORTAL.MANAGE_TRUSTED_DEVICES.THIS_DEVICE' | translate }}</span>
        </mat-basic-chip>
        }
      </div>
    </mat-card-content>
  </pbb-card>
  } @if (isErrorInline && dialogMessageKey) {
  <pbb-notice
    [inline]="isErrorInline"
    [title]="
      dialogMessageKey | translate : (isSuccess ? option.dialogSuccessMessageParams : option.dialogErrorMessageParams)
    "
    id="dialog_action_message"
    [type]="isSuccess ? notice.INFO : notice.ERROR"
    [showInContainer]="false"
  ></pbb-notice>
  }

  <!-- Button container for non-trusted device actions -->
  @if (!option.deleteTrusted && (!!option.confirmButton || !!option.confirmCancel)) {
  <div class="buttons-container">
    @if (!!option.confirmCancel) {
    <button
      (click)="backToMenu()"
      class="cancel-button"
      mat-flat-button
      id="menu_{{ option.action | lowercase }}_cancel-btn"
    >
      {{ isSuccess ? ('COMMON.BUTTON.CLOSE' | translate) : getTranslation(option, 'confirmCancel') }}
    </button>
    } @if (!!option.confirmButton) {
    <button
      class="unlink-button"
      [disabled]="isSuccess"
      (click)="confirm(option)"
      mat-flat-button
      id="menu_{{ option.action | lowercase }}_confirm-btn"
    >
      {{ 'COMMON.BUTTON.REMOVE' | translate }}
    </button>
    }
  </div>
  }

  <!-- Trusted device delete action button -->
  @if (!!option.confirmCancel && option.deleteTrusted) {
  <button
    (click)="backToMenu()"
    class="mt-8"
    id="menu_{{ option.action | lowercase }}_cancel-btn"
    mat-flat-button
    [color]="'accent'"
  >
    {{ isSuccess ? ('COMMON.BUTTON.CLOSE' | translate) : getTranslation(option, 'confirmCancel') }}
  </button>
  } } }
</div>
